export default "__VITE_ASSET__1a24ad12__"